export const CATEGORY = {
  FLOORING: {
    id: '1',
    numericId: 1,
    name: 'Flooring',
    description: 'Detect flooring types, materials, and surface conditions',
  },
  DRYWALL: {
    id: '2',
    numericId: 2,
    name: 'Drywall',
    description: 'Identify drywall surfaces, damage, and repair areas',
  },
  DOORS_WINDOWS: {
    id: '4',
    numericId: 4,
    name: 'Doors & Windows',
    description: 'Locate all door and window openings, types, and configurations',
  },
  INTERIOR_PAINT: {
    id: '5',
    numericId: 5,
    name: 'Interior Paint',
    description: 'Analyze interior paint conditions, coverage, and touch-up needs',
  },
  FIXTURES: {
    id: '6',
    numericId: 6,
    name: 'Plumbing',
    description: 'Locate plumbing fixtures, appliances, and built-in elements',
  },
  HVAC: {
    id: '7',
    numericId: 7,
    name: 'HVAC',
    description: 'Locate Mechanical HVAC trunk lines, ventilation ducting and gas lines',
  },
  COLUMNS: {
    id: '8',
    numericId: 8,
    name: 'Columns',
    description: 'Detect structural columns, column locations, sizes, and support elements throughout the building layout',
  },
  STEEL_BEAMS: {
    id: '9',
    numericId: 9,
    name: 'Steel Beams',
    description: 'Identify structural steel beams, beam layouts, load-bearing members, and framing connections within construction drawings',
  },
} as const;

export type CategoryId = (typeof CATEGORY)[keyof typeof CATEGORY]['id'];
export type CategoryNumericId = (typeof CATEGORY)[keyof typeof CATEGORY]['numericId'];
